<template>
  <div class="wrongQuestion edit-style detail">
    <!-- {{ 111111 }} -->
    <div class="navigation">
      <van-icon name="arrow-left" size="24" @click="downView" />
      <p class="title">试题详情</p>
      <div class="hidden-box"></div>
      <!-- <img src="@/assets/learning/setting.png" alt="" @click="toSetting" /> -->
    </div>

    <div class="question-list">
      <div class="question-list-top">
        <!-- <span class="number">{{ 10 > i + 1 ? "0" + (i + 1) : i + 1 }}</span> -->
        <span class="name">题干</span>
        <!-- <span>{{ getWorngData.difficulty | setName(difficultyList) }}</span> -->
      </div>
      <div class="qusetion-box" v-html="getWorngData.question"></div>
      <div class="btn-box">
        <!-- <span>得分率：{{ getWorngData.scoreRate | setNumber }}</span> -->
        <span>{{ getWorngData.source }}</span>
      </div>
    </div>
    <div v-if="getWorngData.answer" class="question-list">
      <div class="question-list-top">
        <span class="name">答案</span>
      </div>
      <div class="qusetion-box" v-html="getWorngData.answer"></div>
    </div>
    <div v-if="getWorngData.analysis" class="question-list">
      <div class="question-list-top">
        <span class="name">解析</span>
      </div>
      <div class="qusetion-box" v-html="getWorngData.analysis"></div>
    </div>
    <div v-if="getWorngData.analyse" class="question-list">
      <div class="question-list-top">
        <span class="name">分析</span>
      </div>
      <div class="qusetion-box" v-html="getWorngData.analyse"></div>
    </div>
    <div v-if="getWorngData.ability" class="question-list">
      <div class="question-list-top">
        <span class="name">点评</span>
      </div>
      <div class="qusetion-box" v-html="getWorngData.ability"></div>
    </div>
    <div class="btn-bottom">
      <van-button
        v-if="getWorngData.isCorrect == 0"
        :loading="btnLoading"
        type="primary"
        loading-text="加载中..."
        size="large"
        @click="questionCorrect(1)"
        >订正</van-button
      >
      <van-button
        v-if="getWorngData.isCorrect == 1"
        :loading="btnLoading"
        type="primary"
        loading-text="加载中..."
        size="large"
        @click="questionCorrect(0)"
        >取消订正</van-button
      >
    </div>
  </div>
</template>

<script>
//
//
import { Toast } from "vant";
import { questionCorrect } from "@/api/interface";
import { difficultyList } from "@/util/constdata";
import { mapGetters } from "vuex";
export default {
  name: "WrongQuestion",
  data() {
    return {
      btnLoading: false,
      difficultyList: difficultyList,
    };
  },
  computed: {
    ...mapGetters(["getWorngData"]),
  },
  created() {
    // this.getWorngData = this.$route.query.data;
    // console.log(this.getWorngData);
    if (!this.getWorngData.question) {
      this.$router.go(-1);
    }
    // this.getWorngData.type = false;
  },
  mounted() {
    window.MathJax.typesetPromise();
  },
  updated() {
    window.MathJax.startup.defaultReady();
  },
  methods: {
    questionCorrect(val) {
      let data = {
        is_correct: val,
        questionId: this.getWorngData.questionId,
      };
      questionCorrect(data)
        .then(() => {
          if (val == 1) {
            Toast.success("订正成功！");
          } else {
            Toast.success("取消订正成功！");
          }
          this.getWorngData.isCorrect = val;
          this.btnLoading = false;
        })
        .catch(() => {
          this.btnLoading = false;
        });
    },
    downView() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.wrongQuestion {
  .van-button {
    background-color: #7b9cc7;
    border-color: #7b9cc7;
  }
  img {
    max-width: 100%;
    height: auto !important;
  }
}
</style>
<style scoped lang="scss">
.wrongQuestion {
  background-color: rgba(0, 0, 0, 0.04);
  padding: 64px 12px;
  .btn-box {
    border-top: 1px solid rgba(0, 0, 0, 0.5);
    padding-top: 6px;
    display: flex;
    justify-content: space-between;
    span {
      color: rgba(0, 0, 0, 0.5);
    }
  }
  .question-list-top {
    margin-bottom: 6px;
    span {
      margin-right: 6px;
      vertical-align: middle;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
    }
    .number {
      padding: 2px 3px;
      background-color: #7b9cc7;
      border-radius: 50%;
      color: #ffffff;
    }
    .name {
      color: #7b9cc7;
    }
  }
  .btn-bottom {
    padding: 12px;
  }
  .question-list {
    padding: 12px;
    background-color: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 12px;
  }
}
</style>
